import { transactionTypeService } from '../../helpers/services/transactionType.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const TRANSACTION_TYPE_MODULE = 'transactionType'; 

// define action 
export const GET_ALL_TRANSACTION_TYPES = 'getAlltransactionTypes';
export const GET_TRANSACTION_TYPE = 'gettransactionType';
export const UPDATE_TRANSACTION_TYPE = 'updatetransactionType';
export const CREATE_TRANSACTION_TYPE = 'createtransactionType';
export const UPDATE_TRANSACTION_TYPE_STATUS = 'updatetransactionTypeStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_TRANSACTION_TYPE_REQUEST = "getAlltransactionTypes";
const GET_TRANSACTION_TYPE_REQUEST = "gettransactionType";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_TRANSACTION_TYPES]({ commit }, { filter }) {
        transactionTypeService
            .getAlltransactionTypes(filter)
            .then(
                (result) => {
                    commit(GET_ALL_TRANSACTION_TYPE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_TRANSACTION_TYPE]({ commit }, { id }) {
        transactionTypeService
            .gettransactionType(id)
            .then(
                (result) => {
                    commit(GET_TRANSACTION_TYPE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TRANSACTION_TYPE]({ commit }, { data }) {
        commit(REQUEST)
        transactionTypeService
            .updatetransactionType(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.transactiontype')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_TRANSACTION_TYPE]({ commit }, { data }) {
        commit(REQUEST)
        transactionTypeService
            .createtransactionType(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.transactiontype')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TRANSACTION_TYPE_STATUS]({ dispatch }, { filter, data }) {
        transactionTypeService
            .updatetransactionTypeStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_TRANSACTION_TYPES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Transaction-type-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_TRANSACTION_TYPE_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_TRANSACTION_TYPE_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


